// @ts-check
// Configurações > Privacidade > Lixeira (contrato 08 da lixeira; Twenty: Settings > Security, "Erasure of
// soft-deleted records"): dias até a exclusão definitiva automática. Só aparece para a flag SECURITY.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { SettingsSection } from '../settings/settings-pages.js';
import { getTrashSettings, updateTrashSettings } from '../../data/trash.js';
import { Button } from '../../ui/button.js';
import { showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { t } from '../../i18n/index.js';

const MAXIMUM_TRASH_RETENTION_DAYS = 3650;

export function TrashRetentionSection() {
  const [savedDays, setSavedDays] = useState(/** @type {number | null} */ (null));
  const [inputValue, setInputValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    getTrashSettings()
      .then((settings) => {
        setSavedDays(settings.trashRetentionDays);
        setInputValue(String(settings.trashRetentionDays));
      })
      .catch(showErrorSnackbar);
  }, []);

  const days = Number(inputValue);
  const isValid = inputValue.trim() !== '' && Number.isInteger(days) && days >= 0 && days <= MAXIMUM_TRASH_RETENTION_DAYS;

  const save = async () => {
    if (!isValid) return;
    setIsSaving(true);
    try {
      const settings = await updateTrashSettings(days);
      setSavedDays(settings.trashRetentionDays);
      showSuccessSnackbar(t('trash.settings.saved'));
    } catch (error) {
      showErrorSnackbar(error);
    } finally {
      setIsSaving(false);
    }
  };

  return html`<${SettingsSection} title=${t('trash.settings.title')} description=${t('trash.settings.description')}>
    <label class="form-field" for="trash-retention-days">
      <span class="form-field-label">${t('trash.settings.label')}</span>
    </label>
    <div class="trash-retention-row">
      <input id="trash-retention-days" class="text-input" type="number" min="0" max=${MAXIMUM_TRASH_RETENTION_DAYS} step="1" inputmode="numeric" value=${inputValue}
        data-testid="trash-retention-days" disabled=${savedDays === null}
        onInput=${(event) => setInputValue(/** @type {HTMLInputElement} */ (event.currentTarget).value)} />
      <span class="trash-retention-unit">${t('trash.settings.unit')}</span>
      <${Button} title=${t('trash.settings.save')} size="small" variant="secondary" accent="blue" isLoading=${isSaving}
        disabled=${!isValid || savedDays === null || days === savedDays} onClick=${save} />
    </div>
    <p class="channel-card-description">${isValid || inputValue === '' ? t('trash.settings.hint') : t('trash.settings.invalid')}</p>
  <//>`;
}
